// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3L_3a","title":"Header_title__2DRjh","side":"Header_side__QGDum"};